import { Button, Flex } from "@chakra-ui/react"
import ListDocument from "../components/formAgreement/ListDocument"
import { BsFileEarmarkText,BsHouse } from 'react-icons/bs'
import { BlockContainer, BlockContent, BlockHeader } from "../components/shared/Block"
import { Link } from "react-router-dom"

const Regulations = ({homeLink}) => {
    return (
        <Flex p={{base:"",md:"40px"}} direction="column" w="full">
            <BlockContainer>
                <BlockHeader title="กฎ ระเบียบ อาคารที่พักข้าราชการศาลยุติธรรม" icon={BsFileEarmarkText}>
                    {homeLink && <Link to="/"><Button variant="link" leftIcon={<BsHouse />}>กลับหน้าหลัก</Button></Link>}
                </BlockHeader>
                <BlockContent mt={6}>
                    <ListDocument />
                </BlockContent>
            </BlockContainer>
        </Flex>
    )
}

export default Regulations